import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';

const TIPOS_OT = [
  { value: 'SUBPROYECTO', label: 'Subproyecto' },
  { value: 'AUMENTO_OBRA', label: 'Aumento de Obra (AO)' },
];

export const ClasificacionCard = ({ formData, handleChange, subproyectos }) => (
  <Card className="border-2 border-blue-200 bg-blue-50/30">
    <CardHeader className="py-4">
      <CardTitle className="font-heading text-lg text-blue-800">Clasificación para Activo Circulante</CardTitle>
      <p className="text-sm text-blue-600">Define cómo se agrupará esta OT en el informe de Activo Circulante</p>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Tipo de OT */}
        <div className="space-y-2">
          <Label className="font-medium">Tipo de OT *</Label>
          <select
            value={formData.tipo_ot}
            onChange={(e) => handleChange('tipo_ot', e.target.value)}
            className="flex h-10 w-full rounded-md border border-blue-300 bg-white px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-blue-500"
            data-testid="select-tipo-ot"
          >
            {TIPOS_OT.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </select>
        </div>

        {/* Si es Aumento de Obra: Seleccionar Subproyecto existente */}
        {formData.tipo_ot === 'AUMENTO_OBRA' && (
          <div className="space-y-2">
            <Label className="font-medium">Subproyecto Asociado *</Label>
            {subproyectos.length > 0 ? (
              <select
                value={formData.subproyecto_id}
                onChange={(e) => handleChange('subproyecto_id', e.target.value)}
                className="flex h-10 w-full rounded-md border border-orange-300 bg-white px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-orange-500"
                data-testid="select-subproyecto"
              >
                <option value="">Seleccione subproyecto...</option>
                {subproyectos.map((sp) => (
                  <option key={sp.id} value={sp.id}>
                    {sp.nombre} (O/C: {sp.orden_compra || 'N/A'})
                  </option>
                ))}
              </select>
            ) : (
              <div className="p-3 bg-yellow-50 border border-yellow-300 rounded-md">
                <p className="text-sm text-yellow-800">
                  No hay subproyectos definidos para este proyecto.
                  Primero debe crear al menos un Subproyecto.
                </p>
              </div>
            )}
            <p className="text-xs text-orange-600">El AO se asociará a este subproyecto en el Activo Circulante</p>
          </div>
        )}
      </div>

      {/* Info Box según tipo */}
      {formData.tipo_ot === 'SUBPROYECTO' && (
        <div className="p-3 bg-blue-100 border border-blue-300 rounded-md">
          <p className="text-sm text-blue-800">
            <strong>Subproyecto:</strong> Esta OT se agrupará en el Activo Circulante usando su <strong>Descripción</strong> y <strong>Orden de Compra</strong>.
            Las OTs con la misma O/C se mostrarán juntas.
          </p>
        </div>
      )}

      {formData.tipo_ot === 'AUMENTO_OBRA' && (
        <div className="p-3 bg-orange-100 border border-orange-300 rounded-md">
          <p className="text-sm text-orange-800">
            <strong>Aumento de Obra (AO):</strong> Esta OT representa trabajo adicional asociado a un Subproyecto existente.
            Se mostrará agrupada bajo el Subproyecto seleccionado y sus montos se sumarán al total.
          </p>
        </div>
      )}
    </CardContent>
  </Card>
);
